import { materialCompleteUrl, materialInProgressUrl } from "./utils/urls"

const getCSRFToken = () => {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
}

export const completeMaterial = async (materialId: string): Promise<Response | null> => {
  const response = await fetch(materialCompleteUrl(materialId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCSRFToken(),
    }
  })

  if (response.ok) {
    return response.json();
  }

  return null;
}

export const inProgressMaterial = async (materialId: string): Promise<Response | null> => {
  const response = await fetch(materialInProgressUrl(materialId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCSRFToken(),
    }
  })

  if (response.ok) {
    return response.json();
  }

  return null;
}
